function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { cloneDeep, get, omit } from "lodash";
/** Evaluates a single form-level condition expression against the response. */
function evaluateExpression(condition, response) {
  var _condition$observatio;
  var value = get(response, [(_condition$observatio = condition.observation_id) !== null && _condition$observatio !== void 0 ? _condition$observatio : ""], null);
  var numeric = Number(value);
  switch (condition.type) {
    case "expression":
      if (condition.operator === "==") {
        return Array.isArray(value) ? value.includes(condition.value) : value === condition.value;
      }
      if (condition.operator === "!=") {
        return Array.isArray(value) ? !value.includes(condition.value) : value !== condition.value;
      }
      if (condition.operator === "<") return numeric < Number(condition.value);
      if (condition.operator === ">") return numeric > Number(condition.value);
      if (condition.operator === "<=") return numeric <= Number(condition.value);
      if (condition.operator === ">=") return numeric >= Number(condition.value);
      return false;
    case "range":
      return numeric >= Number(condition.min) && numeric <= Number(condition.max);
    case "in_list":
      {
        var _condition$values;
        var values = (_condition$values = condition.values) !== null && _condition$values !== void 0 ? _condition$values : [];
        return Array.isArray(value) ? value.some(function (item) {
          return values.includes(item);
        }) : values.includes(value);
      }
    case "not":
      return value !== condition.value;
    case "exists":
      {
        var present = value !== undefined && value !== null && value !== "";
        return Array.isArray(value) ? value.length > 0 && present : present;
      }
    case "does_not_exists":
      {
        var absent = value === undefined || value === null || value === "";
        return Array.isArray(value) ? value.length === 0 || absent : absent;
      }
    default:
      return false;
  }
}

/** Returns the actions of the first matching form-level condition group. */
export function evaluateFormConditions(groups, response) {
  if (!groups) return [];
  var _iterator = _createForOfIteratorHelper(groups),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var group = _step.value;
      var results = group.constraints.map(function (condition) {
        return evaluateExpression(condition, response);
      });
      var matched = group.type === "and" ? results.every(Boolean) : results.some(Boolean);
      if (matched) return group.actions;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return [];
}

/** Returns the per-field conditions whose target value matches the field's value. */
export function getMatchingFieldConditions(conditions, value) {
  if (!conditions) return [];
  return conditions.filter(function (condition) {
    if (Array.isArray(value)) {
      if (condition.operator === "includes") return value.includes(condition.value);
      if (condition.operator === "excludes") return !value.includes(condition.value);
      return false;
    }
    var scalar = value === null || value === void 0 ? void 0 : value.value;
    return condition.value === scalar || condition.value === value;
  });
}

/** Applies matched field conditions to the schema, dropping disabled field values. */
export function applyFieldConditions(schema, matched, response) {
  var nextResponse = cloneDeep(response);
  var nextSchema = cloneDeep(schema);
  matched.forEach(function (condition) {
    var target = nextSchema.find(function (item) {
      return item.id === condition.component_id;
    });
    if (target) {
      var _condition$actions;
      Object.assign(target, condition.actions);
      if ((_condition$actions = condition.actions) !== null && _condition$actions !== void 0 && _condition$actions.disabled) {
        nextResponse = omit(nextResponse, target.id);
      }
    }
  });
  return {
    schema: nextSchema,
    response: nextResponse
  };
}